import React, { useState } from "react";
import CandidateProfile from "../candidateProfile";
import CandidateInterviewHistory from "../candidateInterviewHistory";
import { Button, Divider } from "antd";
import "./candidateDescription.scss";

function CandidateDescription() {
  const [currentView, setCurrentView] = useState("profile");

  return (
    <>
      <div className="candidate-description-wrapper">
        <div className="candidate-description-buttons-wrapper">
          <Button
            className={`candidate-description-btn ${
              currentView === "profile" && "candidate-description-btn-active"
            }`}
            onClick={(e) => {
              setCurrentView("profile");
            }}
          >
            Profile
          </Button>
          <Button
            className={`candidate-description-btn ${
              currentView === "interview_history" &&
              "candidate-description-btn-active"
            }`}
            onClick={(e) => {
              setCurrentView("interview_history");
            }}
          >
            Interview History
          </Button>
        </div>
        <Divider />
        {currentView === "profile" ? (
          <CandidateProfile />
        ) : currentView === "interview_history" ? (
          <CandidateInterviewHistory />
        ) : null}
      </div>
    </>
  );
}

export default CandidateDescription;
